module.exports = __webpack_public_path__ + "img/home_cn.78cbaa7.jpg";